import {GameStrategy} from '../base/GameStrategy';
import {StaticData} from '../../../data/StaticData';
import {GameScene} from '../../../pixi_scene/GameScene';
import {TableController} from '../../../controllers/silent/TableController';
import {Stack} from '../../../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {CardData, ICardData, MetaType} from '../../../data/active_data/field_config/card_stack_data/CardData';
import {Card} from '../../../pixi_scene/game_scene/game_table/table_objects/stacks/Card';
import {HandEvents} from '../../../pixi_scene/game_scene/hand/HandEvents';
import {ApiSendCommandsController} from '../../../controllers/ApiSendCommandsController';
import {ActiveData} from '../../../data/ActiveData';
import {ArrayWrap} from '../../../data/active_data/base/static_config_data/ArrayWrap';

export class ClueGiverStrategy extends GameStrategy
{
    static stacks: Stack[] | undefined;
    private static gameState: any;

    static handReset(): void {
        GameScene.hand.interactive = GameScene.hand.interactiveChildren = true;
        GameScene.hand.alpha = 1;
    }

    private static onHandTouchableUpdated(): void {
        let guessing: boolean = ClueGiverStrategy.gameState?.automation.informers.stage?.image.indexOf('guess') > -1;
        if (guessing) {
            GameScene.hand.interactive = GameScene.hand.interactiveChildren = false;
            GameScene.hand.alpha = .5;
        } else {
            ClueGiverStrategy.handReset();
        }
        ClueGiverStrategy.updateTrapCard();
    }

    private static removeListener(): void {
        removeEventListener(HandEvents.UPDATED, ClueGiverStrategy.onHandTouchableUpdated);
    }

    private static updateTrapCard(): void {
        let trapCard: Card | undefined = GameScene.hand.backgroundAndCardsHolder.cardsHolder.cards!.find(card => card.activeData.metaType == MetaType.TRAP);
        if (!trapCard) {
            console.log('no trap card!');
            return;
        }

        //кидаем карту-посдказку на первое место
        let trapCardIndex: number = GameScene.hand.backgroundAndCardsHolder.cardsHolder.cards.indexOf(trapCard);
        if (trapCardIndex > 0) {
            let currentPlayerCards: ArrayWrap<CardData, ICardData> = ActiveData.root.getCurrentPlayerData().cards;
            let cardData:CardData = trapCard.activeData;
            currentPlayerCards.remove(cardData);
            ActiveData.dispatchEventsPool();
            currentPlayerCards.unshift(cardData.config!);
            ActiveData.dispatchEventsPool();
            ApiSendCommandsController.changeHandItemsSort(currentPlayerCards.classes.map(cardData => cardData.id), [], false);
            return;
        }
        trapCard.interactive = trapCard.interactiveChildren = trapCard.buttonMode = false;
    }

    isApplicable(gameState: any): boolean {
        let similoGame: boolean = gameState?.tasks?.state?.activity?.name == 'Similo';
        let role: number = gameState?.automation?.playersMap?.[StaticData.playerId]?.role?.value;
        let applicable: boolean = similoGame && role === 1;
        console.warn('CLUEGIVER Strategy aplicable:', applicable);
        return applicable;
    }

    disable(): void {
        if(!this.running){
            return;
        }
        ClueGiverStrategy.removeListener();
        ClueGiverStrategy.handReset();
        super.disable();
    }

    execute(gameState: any): void {
        super.execute(gameState);
        ClueGiverStrategy.gameState = gameState;
        ClueGiverStrategy.stacks = TableController.table.tableObjects!.stacks.stacks;
        console.warn('CLUEGIVER Strategy execute');
        addEventListener(HandEvents.UPDATED, ClueGiverStrategy.onHandTouchableUpdated);
        ClueGiverStrategy.onHandTouchableUpdated();
    }
}
